import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { Wrapper } from '../callingSearch/CallingSearch.styled';
import SearchBox from './components/SearchBox';
import { TABLE_HEADERS } from './constants/table';
import { getTableRows } from './helpers/getTableRows';
import useFollowUpShipments from './hooks/useFollowUpShipments';

const FollowUpShipments = () => {
	const hook = useFollowUpShipments();

	return (
		<>
			{hook.isLoading && <Loading />}
			<Wrapper>
				<SearchBox handleSearchCallback={hook.fetchStaleOrders}></SearchBox>
				{hook.displayedRows && (
					<Table
						className='styled-table'
						raws={getTableRows(hook.displayedRows, hook.openModal)}
						headers={TABLE_HEADERS}
					/>
				)}
			</Wrapper>
		</>
	);
};

export default FollowUpShipments;
